import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Package, ScanLine } from 'lucide-react';

const CATEGORIE = ['Registratori', 'Stampanti', 'Accessori', 'Consumabili', 'Ricambi', 'Altro'];

/** Step 1 del carico multiplo: scelta modalità + dati template prodotto. */
export const BulkStepTemplate = ({ mode, setMode, template, setTemplate, isSuperAdmin }) => (
  <div className="space-y-3 py-2">
    {/* Scelta modalità */}
    <div className="grid grid-cols-2 gap-2">
      <button
        type="button"
        onClick={() => setMode('codici')}
        className={`p-3 border text-left transition-colors ${mode === 'codici' ? 'border-cyan-500 bg-cyan-50 dark:bg-cyan-950/20' : 'border-border hover:bg-muted/50'}`}
        data-testid="bulk-mode-codici"
      >
        <div className="flex items-center gap-2 font-semibold text-sm">
          <ScanLine className="h-4 w-4 text-cyan-600" />
          Unità con codici
        </div>
        <div className="text-[11px] text-muted-foreground mt-1">Casse/stampanti: scansiona EAN o matricola di ogni pezzo</div>
      </button>
      <button
        type="button"
        onClick={() => setMode('quantita')}
        className={`p-3 border text-left transition-colors ${mode === 'quantita' ? 'border-cyan-500 bg-cyan-50 dark:bg-cyan-950/20' : 'border-border hover:bg-muted/50'}`}
        data-testid="bulk-mode-quantita"
      >
        <div className="flex items-center gap-2 font-semibold text-sm">
          <Package className="h-4 w-4 text-cyan-600" />
          Solo quantità
        </div>
        <div className="text-[11px] text-muted-foreground mt-1">Consumabili: es. 10 rotoli carta, senza codici</div>
      </button>
    </div>
    <div>
      <Label className="text-xs font-mono uppercase">Descrizione prodotto *</Label>
      <Input
        value={template.descrizione}
        onChange={(e) => setTemplate({ ...template, descrizione: e.target.value })}
        placeholder="Es. Cassa Fiscale Epson TM-88"
        data-testid="bulk-descrizione"
        className="rounded-none"
        autoFocus
      />
    </div>
    <div className="grid grid-cols-2 gap-3">
      <div>
        <Label className="text-xs font-mono uppercase">Marca</Label>
        <Input
          value={template.marca}
          onChange={(e) => setTemplate({ ...template, marca: e.target.value })}
          placeholder="Epson"
          data-testid="bulk-marca"
          className="rounded-none"
        />
      </div>
      <div>
        <Label className="text-xs font-mono uppercase">Modello</Label>
        <Input
          value={template.modello}
          onChange={(e) => setTemplate({ ...template, modello: e.target.value })}
          placeholder="TM-88"
          data-testid="bulk-modello"
          className="rounded-none"
        />
      </div>
    </div>
    <div className="grid grid-cols-2 gap-3">
      <div>
        <Label className="text-xs font-mono uppercase">Categoria</Label>
        <Select value={template.categoria} onValueChange={(v) => setTemplate({ ...template, categoria: v })}>
          <SelectTrigger className="rounded-none" data-testid="bulk-categoria">
            <SelectValue placeholder="Seleziona" />
          </SelectTrigger>
          <SelectContent>
            {CATEGORIE.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <div>
        <Label className="text-xs font-mono uppercase">Prefisso codice interno</Label>
        <Input
          value={template.codice_prefix}
          onChange={(e) => setTemplate({ ...template, codice_prefix: e.target.value })}
          placeholder="Es. CASSA-EP"
          data-testid="bulk-prefix"
          className="rounded-none font-mono"
        />
      </div>
    </div>
    <div className="grid grid-cols-2 gap-3">
      {isSuperAdmin && (
        <div>
          <Label className="text-xs font-mono uppercase flex items-center gap-1">
            Prezzo Acquisto (€)
            <span className="text-[9px] bg-amber-100 text-amber-800 dark:bg-amber-950 dark:text-amber-300 px-1 py-0.5 rounded font-bold">SUPER ADMIN</span>
          </Label>
          <Input
            type="number" step="0.01"
            value={template.prezzo_acquisto}
            onChange={(e) => setTemplate({ ...template, prezzo_acquisto: e.target.value })}
            data-testid="bulk-prezzo-acquisto"
            className="rounded-none font-mono"
          />
        </div>
      )}
      <div className={isSuperAdmin ? '' : 'col-span-2'}>
        <Label className="text-xs font-mono uppercase">Prezzo Vendita (€)</Label>
        <Input
          type="number" step="0.01"
          value={template.prezzo_vendita}
          onChange={(e) => setTemplate({ ...template, prezzo_vendita: e.target.value })}
          data-testid="bulk-prezzo-vendita"
          className="rounded-none font-mono"
        />
      </div>
    </div>
  </div>
);
